import * as React from 'react';
import "./EntityItem.scss";
import classnames from 'classnames';
import { Collapse } from 'reactstrap';
import { Tab } from '@material-ui/core';
import AppTabs from '../../../components/AppTabs';


export interface EntityItemTab {
    id: string,
    title: string,
    render: (isOpen: boolean, onClose: () => void) => React.ReactElement,
}

export interface EntityItemStateProps {
    id: string,
    isOpen: boolean,
    tabs: EntityItemTab[],
    refObj?: React.RefObject<HTMLDivElement>,
    renderHeader: () => React.ReactElement,
    activeTab: string,
}

export interface EntityItemDispatchProps {
    onOpen: () => void,
    onClose: () => void,
    onTabChange: (tabId: string) => void,
}

export type EntityItemProps = EntityItemStateProps & EntityItemDispatchProps;

const EntityItem: React.FC<EntityItemProps> = (props) => {
    const {
        id,
        isOpen,
        renderHeader,
        tabs,
        refObj,
        onClose,
        onOpen,
        activeTab,
        onTabChange,
    } = props;

    const resolvedTab = (activeTab && tabs.some(t => t.id === activeTab)) ? activeTab : (tabs[0]?.id ?? '');

    const [shouldRenderContent, setRenderContent] = React.useState(isOpen);
    const isOpenRef = React.useRef(isOpen);

    React.useEffect(() => {
        isOpenRef.current = isOpen;
        if (isOpen) setRenderContent(true);
    }, [isOpen]);

    const handleToggle = React.useCallback(() => isOpen ? onClose() : onOpen(), [isOpen, onClose, onOpen])

    const handleCollapseExited = React.useCallback(() => {
        if (!isOpenRef.current) setRenderContent(false);
    }, []);

    return (
        <div id={`${id}-container`} className="entityContainer">
            <div className="header" ref={refObj} style={{cursor: 'pointer'}}>
                <div className={classnames({"active": isOpen, "leftContainer": true})} onClick={handleToggle}>
                    {renderHeader()}
                </div>
            </div>
            <Collapse isOpen={isOpen} onExited={handleCollapseExited}>
                { shouldRenderContent && (<>
                    {
                        tabs.length > 1 &&
                            <AppTabs value={resolvedTab} onChange={(_, v) => onTabChange(v as string)} className="entityTabsBar" style={{ borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}>
                                { tabs.map(tab => <Tab key={tab.id} value={tab.id} label={tab.title} />)}
                            </AppTabs>
                    }
                    { tabs.map(tab => (
                        <div key={tab.id} style={tab.id !== resolvedTab ? { display: 'none' } : undefined}>
                            {tab.render(tab.id === resolvedTab, onClose)}
                        </div>
                    ))}
                </>)}
            </Collapse>
        </div>
    );
}

export default EntityItem;
